<template>
    <div class="form-dynamic-wrapper mb-2">
        <b-row class="pr-5">
            <b-col md="4">
                <b-form-group>
                    <b-form-input v-model="kelengkapan.name" name="kelengkapanName" placeholder="Name" class="mr-2" required></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="form-dynamic-deleteWrapper">
            <b-row>
                <b-button class="btn-dynamicActiveBtn mr-2" name="deleteKelengkapan" @click="$emit('aktif', kelengkapan.index)"><i class="fa fa-plus"></i></b-button>
                <!-- <b-button variant="dynamicDeleteBtn ml-2 mr-2" name="deleteKelengkapan" @click="$emit('remove', kelengkapan.index)"><i class="fa fa-times"></i></b-button> -->
            </b-row>
        </div>
    </div>
</template>

<script>
export default {
    name: 'kelengkapan-non-aktif',
    props: {
        kelengkapan: { type: Object, required: true },
        length: { type: Number, required: true }
    }
}
</script>
